import axios from 'axios/index';
import $ from 'jquery';
import dayjs from 'dayjs';
import * as _ from 'lodash';

import { PARAMS } from '../../const';
import {
  API_BACKOFFICE_CUSTOMERS_BOOKS_METAS,
  API_EXTERNAL_SCHOOLS_BOOKS,
  API_BACKOFFICE_TEMPLATE,
  API_CDN_VERSION,
  API_BACKOFFICE_SKIN_VERSION,
  API_BACKOFFICE_SCHOOLS_CONFIGURATION,
  API_BACKOFFICE_AUTHORIZATION
} from './apiConst';
import {
  API_EXTERNAL_ACTIVITY_RESULTS,
  API_EXTERNAL_ACTIVITY_TRACKING_SUMMARY,
  API_EXTERNAL_ACTIVITY_TRACKING_ALL_STUDENTS,
  API_EXTERNAL_ACTIVITY_TRACKING_STUDENT,
  API_EXTERNAL_ACTIVITY_TRACKING_INSTRUCTOR
} from './apiConst';
import { manageArrayResponse } from './apiResponse';
import { getLogger } from '../logger';

const COLORS_JSON_FILE = 'colors.json';
const LAYOUT_JSON_FILE = 'layout.json';
const VERSION_JSON_FILE = 'version.json';

const debug = getLogger('services:api:external:cmi5Api');

let getQueryMetadatas = metadatas => {
  if (metadatas[Object.keys(metadatas)[0]] === undefined) return '';

  let metadataQuery = '';
  _.forOwn(metadatas, (metadataValues, metadataId) => {
    if (metadataValues.length && metadataId) {
      if (!_.isEmpty(metadataQuery)) {
        metadataQuery += '_';
      }
      let metaId = metadataValues.join();
      metadataQuery += metadataValues.join() ? `${metadataId}[${metaId}]` : '0';
    }
  });

  return metadataQuery.length ? `&metadata=${metadataQuery}` : '';
};

//----------------------------------------------------------------------------------------------------------------------
export let getLibraryBooks = (institutionId, metadatas, tags, page, size) => {
  if (institutionId && page !== undefined && size !== undefined) {
    let url = API_EXTERNAL_SCHOOLS_BOOKS.replace(PARAMS.SCHOOL, institutionId);
    let query = metadatas ? getQueryMetadatas(metadatas) : '&metadata=0';

    query += '&fetchUnits=false';

    if (tags && tags.length) query += `&tags=${formatTags(tags)}`;

    let queryUrl = `?page=${page}&size=${size}${query}`;
    return axios.get(`${url}${queryUrl}`);
  }

  debug.error('[getLibraryBooks] institutionId: %s | page: %s | size: %s', institutionId, page, size);
};

export let getLibraryBook = (institutionId, metadataUri) => {
  if (institutionId && metadataUri) {
    let url = API_EXTERNAL_SCHOOLS_BOOKS.replace(PARAMS.SCHOOL, institutionId);

    let queryUrl = `?bookUri=${metadataUri}`;
    return axios.get(`${url}${queryUrl}`);
  }

  debug.error('[getLibraryBook] institutionId: %s | metadataUri: %s', institutionId, metadataUri);
};

//----------------------------------------------------------------------------------------------------------------------
export let getLibraryFilters = customerId => {
  if (customerId) {
    return axios.get(API_BACKOFFICE_CUSTOMERS_BOOKS_METAS.replace(PARAMS.CUSTOMER, customerId));
  }
  debug.error('[getLibraryFilters] Customer is empty');
};

//----------------------------------------------------------------------------------------------------------------------
export let getSkinUrlTemplate = customerId => {
  if (customerId) {
    let url = API_BACKOFFICE_TEMPLATE.replace(PARAMS.CUSTOMER, customerId);
    return axios.get(url);
  }
  debug.error('[getSkinUrlTemplate] customerId is empty');
};

//----------------------------------------------------------------------------------------------------------------------
export let getThemeVersion = url => {
  return getThemeJson(`${url}/${VERSION_JSON_FILE}`);
};

//----------------------------------------------------------------------------------------------------------------------
export let getThemeColors = url => {
  return getThemeJson(`${url}/${COLORS_JSON_FILE}`);
};

//----------------------------------------------------------------------------------------------------------------------
export let getThemeLayout = url => {
  return getThemeJson(`${url}/${LAYOUT_JSON_FILE}`);
};

//----------------------------------------------------------------------------------------------------------------------
let getThemeJson = url => {
  if (url) {
    return $.getJSON(url);
  }
  debug.error('[getThemJson] url is empty');
};

//----------------------------------------------------------------------------------------------------------------------
export let getActivityTrackingForAllStudents = (sectionId, activities, dueDate, students) => {
  let query = '';

  if (sectionId && dueDate && students) {
    if (sectionId) query = `${query}?sectionId=${sectionId}`;
    if (dueDate) query = `${query}&timestamp=${dayjs(dueDate).valueOf()}`;

    let payload = {
      activities,
      students
    };

    return axios.post(`${API_EXTERNAL_ACTIVITY_TRACKING_ALL_STUDENTS}${query}`, payload);
  }

  return Promise.reject(
    `Empty mandatory parameters : sectionId(${sectionId}) students(${students}) dueDate(${dueDate})`
  );
};

//----------------------------------------------------------------------------------------------------------------------
export let getActivityTrackingSummary = (sectionId, activities, dueDate, students) => {
  let query = '';

  if (sectionId && dueDate && students) {
    if (sectionId) query = `${query}?sectionId=${sectionId}`;
    if (dueDate) query = `${query}&timestamp=${dayjs(dueDate).valueOf()}`;

    let payload = {
      activities,
      students
    };

    return axios.post(`${API_EXTERNAL_ACTIVITY_TRACKING_SUMMARY}${query}`, payload);
  }

  return Promise.reject(
    `Empty mandatory parameters : sectionId(${sectionId}) students(${students}) dueDate(${dueDate})`
  );
};

//----------------------------------------------------------------------------------------------------------------------
export let getActivitisStateInstructor = (sectionId, unitUri) => {
  let query = '';
  if (sectionId && unitUri) {
    query = `?sectionId=${sectionId}&unitUri=${unitUri}`;
    return axios.get(`${API_EXTERNAL_ACTIVITY_TRACKING_INSTRUCTOR}${query}`);
  }
};

//----------------------------------------------------------------------------------------------------------------------
/*
  @Deprecated use getActivityTrackingSummary instead
 */
export let getActivityStateForStudent = (sectionId, activities, studentId, dueDate) => {
  let query = '';
  if (sectionId && studentId && dueDate) {
    if (sectionId) query = `${query}?sectionId=${sectionId}`;
    if (studentId) query = `${query}&userId=${studentId}`;
    if (dueDate) query = `${query}&timestamp=${dayjs(dueDate).valueOf()}`;

    return axios.post(`${API_EXTERNAL_ACTIVITY_TRACKING_STUDENT}${query}`, activities);
  }

  return Promise.reject(
    `Empty mandatory parameters : sectionId(${sectionId}) studentId(${studentId}) dueDate(${dueDate})`
  );
};

//----------------------------------------------------------------------------------------------------------------------
export let getStudentResults = (from, to, sectionId, userId) => {
  let query = '?';

  if (sectionId && from && to) {
    query = `${query}sectionId=${sectionId}`;
    query = `${query}&from=${from}`;
    query = `${query}&to=${to}`;
    if (userId) query = `${query}&userId=${userId}`;
    return manageArrayResponse(axios.get(`${API_EXTERNAL_ACTIVITY_RESULTS}${query}`));
  }

  debug.error('[getStudentResults] sectionId: %s | from: %s | to: %s', sectionId, from, to);
  Promise.reject('sectionId or from or to is empty');
};

//----------------------------------------------------------------------------------------------------------------------
let formatTags = tags => {
  return JSON.stringify(tags);
};

//----------------------------------------------------------------------------------------------------------------------
export let getCdnVersion = () => {
  return axios.get(API_CDN_VERSION, {});
};

//----------------------------------------------------------------------------------------------------------------------
export let getSkinVersion = customerId => {
  if (customerId) {
    const url = API_BACKOFFICE_SKIN_VERSION.replace(PARAMS.CUSTOMER, customerId);
    return axios.get(url);
  }

  debug.error('[getSkinVersion] customerId: %s', customerId);
};

//----------------------------------------------------------------------------------------------------------------------
export let getCustomerConfiguration = (customerId, schoolId) => {
  if (customerId) {
    const url = `${API_BACKOFFICE_SCHOOLS_CONFIGURATION}`.replace(PARAMS.CUSTOMER, customerId);
    return axios.get(url.replace(PARAMS.SCHOOL, schoolId));
  }
};

export let checkAuthorization = (userId, schoolId) => {
  const url = `${API_BACKOFFICE_AUTHORIZATION}`;

  const data = {
    user: userId,
    schoolId: schoolId
  };

  return axios.post(url, data);
};
